export const STORAGE_KEY_IS_PWA_INSTALLED = "is-pwa-installed";
